import { useCallback } from 'react';

import { MobileField } from '@components/MobileCardList';
import { ColumnsType } from '@components/Table';
import { RowHandlers } from '@components/Table/VirtualTable';

import { OrganizationRow, useColumns } from './useColumns';
import { useCreationMenu } from './useCreationMenu';
import { useMobileFields } from './useMobileFields';
import { useTableData } from './useTableData';

interface LegalEntityWithOrganizations {
    legalEntityId: string;
    name: string;
    organizations: OrganizationRow[];
}

interface Data {
    data: LegalEntityWithOrganizations[];
    columns: ColumnsType<OrganizationRow>;
    mobileFields: MobileField<OrganizationRow>[];
    onRow(record: OrganizationRow): RowHandlers;
    onMobileCardClick(record: OrganizationRow): void;
}

export function useOrganizationDataPage(): Data {
    const { data } = useTableData();
    const { columns } = useColumns();
    const { mobileFields } = useMobileFields();
    const { openEditMenu } = useCreationMenu();

    const onRow = useCallback(
        (record: OrganizationRow): RowHandlers => ({
            onClick: () => openEditMenu(record),
        }),
        [openEditMenu],
    );

    const onMobileCardClick = useCallback((record: OrganizationRow) => openEditMenu(record), [openEditMenu]);

    return {
        data,
        columns,
        mobileFields,
        onRow,
        onMobileCardClick,
    };
}
